import React from "react";

import Blocks from "components/form/Blocks";

import useTemplateApi from "hooks/api/private/useTemplateApi";

function TemplateBlocksForm({ templateId }: { templateId: string }) {
    const { getOneTemplate } = useTemplateApi();

    const [blockGroupId, setBlockGroupId] = React.useState<string | null>(null);

    React.useEffect(() => {
        if (templateId) {
            const [apiCall, abortController] = getOneTemplate({ id: templateId });

            apiCall.then((template) => setBlockGroupId(template.block_group_id));

            return () => abortController.abort();
        }
    }, [getOneTemplate, templateId]);

    return <>{blockGroupId && <Blocks blockGroupId={blockGroupId} />}</>;
}

export default TemplateBlocksForm;
